import {IconButton, MenuItem, Paper} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OutlinedSelect from 'Shared/components/OutlinedSelect';
import {changeBeneficiariesRole, removeUserType} from 'Users/ducks/userEntry';
import {Application} from 'Users/models/Application';
import {
  BeneficiariesRole,
  InvalidBeneficiariesUserType,
  ValidBeneficiariesUserType,
} from 'Users/models/User/BeneficiariesUserType';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './BeneficiariesUserTypeEntry.sass';
import {Scope} from 'Shared/constants/Scope';
import {hasAccessToScopeByApplication} from 'Shared/utilities/applicationId';

type BeneficiariesUserTypeEntryProps = {
  beneficiariesUserType: InvalidBeneficiariesUserType | ValidBeneficiariesUserType;
  isEdit: boolean;
};

const BeneficiariesUserTypeEntry = (props: BeneficiariesUserTypeEntryProps) => {
  const dispatch = useDispatch();
  const {beneficiariesUserType} = props;
  const {beneficiariesRole} = beneficiariesUserType.value;

  const scopes = useSelector(selectUserScopes);
  const hasUpdateAccess = hasAccessToScopeByApplication(scopes, Scope.UpdateUser, Application.Beneficiary);

  return (
    <Paper className="beneficiaries-user-type-entry">
      <IconButton
        className="beneficiaries-user-type-entry__remove-button"
        onClick={() => dispatch(removeUserType(beneficiariesUserType))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <Close />
      </IconButton>
      <p className="beneficiaries-user-type-entry__title">Add Beneficiaries Permissions</p>
      <p className="beneficiaries-user-type-entry__description">
        Select a role and complete the appropriate fields to add Beneficiaries permissions to this user.
      </p>
      <OutlinedSelect
        className="beneficiaries-user-type-entry__role-select"
        label="Beneficiaries Role"
        value={beneficiariesRole || ''}
        onChange={e => dispatch(changeBeneficiariesRole(parseInt(e.target.value, 10) as BeneficiariesRole))}
        disabled={!hasUpdateAccess && props.isEdit}
      >
        <MenuItem value={BeneficiariesRole.Admin}>Admin</MenuItem>
      </OutlinedSelect>
    </Paper>
  );
};

export default BeneficiariesUserTypeEntry;
